<div class="counter-element">
  <span class="count {{automationClass}}">{{counter}}</span>
  <span class="element-title">{{elementTitle}}</span>
</div>
